<template>
    <VSelect
        v-model="val"
        :variant="variant"
        :label="label"
        :items="items"
        :itemProps="getProps"
        :placeholder="placeholder"
        :persistentPlaceholder="persistent"
        :density="density"
        :prefix="prefix"
        :suffix="suffix"
        :messages="messages"
        :disabled="disabled"
        :readonly="readonly"
        :clearable="clearable"
        :loading="loading"
        :errorMessages="errorMessages"
        :noDataText="t({ key: 'shared.no_alternatives' })"
        :openText="t({ key: 'shared.open' })"
        :closeText="t({ key: 'shared.close' })" />
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent, watch, ref, PropType } from 'vue';
    import isEqual from 'lodash/isEqual';
    import { VSelect } from 'vuetify/components';
    import { SelectItem, Variant, Density } from '../../Shared/interfaces/Select.interfaces';

    export default defineComponent({
        name: 'Select',
        methods: { t },
        components: { VSelect },
        emits: ['update:modelValue'],
        props: {
            modelValue: { type: [String, Object, Number] },
            items: { type: Array as PropType<SelectItem[]>, default: () => [] },
            label: String,
            placeholder: String,
            prefix: String,
            suffix: String,
            loading: { type: Boolean as PropType<boolean>, default: false },
            disabled: { type: Boolean as PropType<boolean>, default: false },
            clearable: { type: Boolean as PropType<boolean>, default: false },
            readonly: { type: Boolean as PropType<boolean>, default: false },
            messages: { type: Array as PropType<string[]> },
            errorMessages: {
                type: [Array, String] as PropType<string[] | string>,
            },
            variant: { type: String as PropType<Variant>, default: 'outlined' },
            density: { type: String as PropType<Density>, default: 'default' },
        },
        setup(props, { emit }) {
            const val = ref<any | undefined>(props.modelValue);
            const persistent = computed(() => Boolean(val.value));

            watch(
                () => props.modelValue,
                (newValue, prevValue) => {
                    if (!isEqual(newValue, prevValue)) {
                        val.value = newValue;
                    }
                }
            );

            watch(
                () => val.value,
                (newValue, prevValue) => {
                    if (!isEqual(newValue, prevValue)) {
                        emit('update:modelValue', newValue);
                    }
                }
            );

            const getProps = (item: SelectItem) => {
                return {
                    title: item.label,
                    subtitle: item.subLabel,
                };
            };

            return {
                val,
                persistent,
                getProps,
            };
        },
    });
</script>
